/* Outlet-extra's op de productpagina: prijsregel bijwerken, 'Laat het me weten' bij uitverkochte maat */
(function () {
  'use strict';
  function cents(str) { var m = (str || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'); var n = parseFloat(m); return isNaN(n) ? 0 : Math.round(n * 100); }
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  function init() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var note = document.querySelector('[data-price-note]');
    var noteCompare = note && note.querySelector('[data-note-compare]');
    var noteSave = note && note.querySelector('[data-note-save]');
    var buyBtn = form.querySelector('[data-add-to-cart]');
    var restock = form.querySelector('[data-restock]');
    var idInput = form.querySelector('input[name="id"]');
    var tagsInput = document.querySelector('[data-restock-popup] [data-signup-tags]');
    var variantLabel = document.querySelector('[data-restock-variant]');
    var handle = form.dataset.productHandle || '';

    function updateNote() {
      if (!note || !priceEl || !compareEl) return;
      var p = cents(priceEl.textContent), c = cents(compareEl.textContent);
      var on = !compareEl.hidden && c > p;
      note.hidden = !on;
      if (on) { if (noteCompare) noteCompare.textContent = money(c); if (noteSave) noteSave.textContent = money(c - p); }
    }
    function variantTitle() {
      var vals = Array.prototype.map.call(form.querySelectorAll('[data-selected-value]'), function (s) { return s.textContent.trim(); }).filter(Boolean);
      return vals.join(' / ');
    }
    function updateRestock() {
      if (!restock || !buyBtn) return;
      var out = buyBtn.disabled;
      restock.classList.toggle('is-visible', out);
      if (out) {
        var title = variantTitle();
        var vid = idInput ? idInput.value : '';
        if (variantLabel) variantLabel.textContent = (document.querySelector('.product-info h1') || {}).textContent ? (document.querySelector('.product-info h1').textContent.trim() + (title ? ' — ' + title : '')) : title;
        if (tagsInput) {
          var base = tagsInput.dataset.base || tagsInput.value; tagsInput.dataset.base = base;
          tagsInput.value = base + (handle ? ', restock-' + handle : '') + (vid ? ', restock-' + vid : '');
        }
      }
    }
    if (window.MutationObserver) {
      if (compareEl) new MutationObserver(updateNote).observe(compareEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      if (priceEl) new MutationObserver(updateNote).observe(priceEl, { childList: true, characterData: true, subtree: true });
      if (buyBtn) new MutationObserver(updateRestock).observe(buyBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
    form.addEventListener('change', function () { setTimeout(function () { updateNote(); updateRestock(); }, 30); });
    updateNote(); updateRestock();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
